import React, { useState } from "react";
import { IconButton, Switch } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { activeDeactivateUserApi } from "API/apis/admin/users/activeDeactivateUser";
import { STATUS_CODES } from "constants/responses/statusCodes";
import { useGlobalContext } from "context/GlobalContext";
import { useUsersContext } from "../context";
import { UpdateUserFormModal } from "./UpdateUserFormModal";
import { LockReset } from "@mui/icons-material";
import { resetPasswordApi } from "API/apis/admin/users/resetPassword";
import { message } from "constants/responses/message";
import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { confirmAction } from "utils/functions/confirmAction";
import { UpdateUserPermissionFormModal } from "./UpdateUserPermissionFormModal";
import { ReactTable } from "components/ReactTable/ReactTable";
import { AvatarProfilePic } from "components/Avatar/AvatarProfilePic";

const initialValuePermissionData = {
  userId: "",
  permission: {},
};
export const UsersList = () => {
  const { setSuccess, setError, setIsLoading } = useGlobalContext();
  const [openModal, setOpenModal] = useState(false);
  const [openPermissionModal, setOpenPermissionModal] = useState(false);
  const [currentPermissionData, setCurrentPermissionData] = useState(
    initialValuePermissionData
  );
  const [currentFormData, setCurrentFormData] = useState({
    userId: "",
    email: "",
    username: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    deptId: 0,
    mgrUserId: "",
    mgrName: "",
  });
  const { list, setList } = useUsersContext();
  const [selectedRowId, setSelectedRowId] = useState();

  const handleEdit = (row) => {
    setOpenModal(true);
    setCurrentFormData({
      userId: row.userId,
      username: row.username,
      email: row.email,
      firstName: row.firstName,
      lastName: row.lastName,
      phoneNumber: row.phoneNumber,
      deptId: row.deptId,
      mgrUserId: row.mgrUserId,
      mgrName: row.mgrName,
    });
  };
  const handlePermissionUpdate = (row) => {
    setOpenPermissionModal(true);
    setCurrentPermissionData({
      permission: row.permission,
      userId: row.userId,
    });
  };
  const handleStatusChange = async (row) => {
    try {
      setIsLoading(true);
      const { data, status } = await activeDeactivateUserApi({
        status: !row.isUserActive,
        userId: row.userId,
      });
      if (status === STATUS_CODES.SUCCESS) {
        const updatedData = list.map((item) => {
          return {
            ...item,
            isUserActive:
              item.userId === row.userId
                ? !item.isUserActive
                : item.isUserActive,
          };
        });
        setList(updatedData);
        setSuccess(data.message);
      } else {
        throw new Error(data.message);
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };
  const handleResetPasswordChange = async (userId) => {
    const confirmed = confirmAction(message.info.proceedConfirmBoxMessage);
    if (confirmed) {
      try {
        setIsLoading(true);
        const { data, status } = await resetPasswordApi(userId);
        if (status === STATUS_CODES.SUCCESS) {
          setSuccess(data.message);
        } else {
          throw new Error(data.message);
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    } else {
      return;
    }
  };

  const columnsForReactTable = [
    {
      accessorKey: "firstName",
      header: "Name",
      cell: ({ row }) => (
        <AvatarProfilePic
          firstName={row.original.firstName}
          profilePicture={row.original.profilePicture}
        />
      ),
    },
    { accessorKey: "lastName", header: "Last Name" },
    { accessorKey: "username", header: "Username" },
    { accessorKey: "email", header: "Email" },
    { accessorKey: "phoneNumber", header: "Contact" },
    { accessorKey: "dept", header: "Department" },
    {
      accessorKey: "permission",
      header: "Permission",
      cell: ({ row }) => (
        <IconButton onClick={() => handlePermissionUpdate(row.original)}>
          <EditIcon />
        </IconButton>
      ),
    },
    {
      accessorKey: "isUserActive",
      header: "IS Active",
      cell: ({ row }) => (
        <Switch
          checked={row.original.isUserActive}
          onChange={() => {
            handleStatusChange(row.original);
          }}
          inputProps={{ "aria-label": "controlled" }}
        />
      ),
    },
    {
      accessorKey: "resetPassword",
      header: "Reset Password",
      cell: ({ row }) => (
        <IconButton
          onClick={() => handleResetPasswordChange(row.original.userId)}
        >
          <LockReset fontSize="large" />
        </IconButton>
      ),
    },
    {
      accessorKey: "edit",
      header: "Edit",
      cell: ({ row }) => (
        <IconButton onClick={() => handleEdit(row.original)}>
          <EditIcon />
        </IconButton>
      ),
    },
  ];
  return (
    <>
      <PageTitle pageName={pageName.admin.users.usersList} />
      {/* <Button onClick={handleClearFilter}>Clear Filter</Button> */}
      <UpdateUserFormModal
        title={pageName.admin.users.updateUser}
        openModal={openModal}
        setOpenModal={setOpenModal}
        currentFormData={currentFormData}
      />
      <UpdateUserPermissionFormModal
        title={pageName.admin.users.updatePermission}
        openModal={openPermissionModal}
        setOpenModal={setOpenPermissionModal}
        currentPermissionData={currentPermissionData}
        setCurrentPermissionData={setCurrentPermissionData}
      />
      <div style={{ width: "100%" }}>
        <ReactTable
          data={list}
          columns={columnsForReactTable}
          selectedRowId={selectedRowId}
          setSelectedRowId={setSelectedRowId}
        />
      </div>
    </>
  );
};
